import { FC } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { BUSINESS_TYPE } from '@/api/types';
import cn from '@/utils/cn';

import AddCoowner from './AddCoowner';
import { PersonDataVehicleInputs } from './PersonDataVehicleInputs';

const PersonDataVehicle: FC = () => {
  const { data } = useFormDataQuery();

  const businessType = data?.offer.business_type ?? null;
  const displayCompany = businessType && businessType !== BUSINESS_TYPE.JDG;

  const defaultValues = {
    phone: data?.user?.phone ?? '',
    email: data?.user?.email ?? '',
    first_name: data?.user?.first_name ?? '',
    last_name: data?.user?.last_name ?? '',
  };

  return (
    <SectionWrapper displayCompany={!!displayCompany}>
      <PersonDataVehicleInputs
        recipientType={businessType}
        defaultValues={defaultValues}
      />
      <AddCoowner recipientType={businessType} defaultValues={defaultValues} />
    </SectionWrapper>
  );
};

export default PersonDataVehicle;

export const SectionWrapper = ({
  displayCompany,
  children,
}: {
  displayCompany: boolean;
  children: React.ReactNode;
}) => {
  return displayCompany ? (
    <>{children}</>
  ) : (
    <section
      className={cn(
        'w-full max-w-full space-y-4 rounded-[10px] border-t-[6px] border-blue-600 bg-gray-100 px-3.5 py-4 md:space-y-5 md:rounded-lg md:p-6'
      )}
    >
      {children}
    </section>
  );
};
